import { isSensitiveAnalyticsUrl } from './analyticsUrl.ts'

export type InteractionArea = 'header' | 'footer' | 'article' | 'main'

export function sitePageType(pathname: string): string {
  if (pathname === '/') return 'home'
  if (pathname.startsWith('/blog/')) return 'blog'
  if (pathname.startsWith('/products')) return 'product_database'
  if (pathname === '/risk-checker') return 'tool_risk_checker'
  if (pathname === '/microplastic-ingredient-checker') return 'tool_ingredient_checker'
  return 'static'
}

/** Only authored action IDs and public destinations are collected, never DOM text. */
export function describeSiteInteraction(input: {
  currentUrl: string
  area: InteractionArea
  href?: string | null
  action?: string | null
}): { name: 'site_link_click' | 'site_button_click'; properties: Record<string, string> } | null {
  if (isSensitiveAnalyticsUrl(input.currentUrl)) return null
  const current = new URL(input.currentUrl)
  const common = {
    cta_surface: `site_${input.area}`,
    page_type: sitePageType(current.pathname),
  }

  if (input.action && /^[a-z][a-z0-9_-]{1,79}$/.test(input.action)) {
    return {
      name: 'site_button_click',
      properties: { ...common, destination: input.action },
    }
  }
  if (!input.href) return null
  try {
    const url = new URL(input.href, current)
    if (!['https:', 'http:'].includes(url.protocol)) return null
    if (url.username || url.password || isSensitiveAnalyticsUrl(url.href)) return null
    if (/@|[\r\n]/.test(decodeURIComponent(url.pathname))) return null

    // AppStoreLink owns its conversion events. Do not add another click event.
    if (url.hostname === 'apps.apple.com') return null
    const internal = url.origin === current.origin
    const anchor = internal && url.pathname === current.pathname && Boolean(url.hash)
    // Hash values and query strings can hold arbitrary user input. Keep only
    // a public path (internal) or hostname (external).
    const destination = internal ? url.pathname : url.hostname
    return {
      name: 'site_link_click',
      properties: {
        ...common,
        destination: destination.slice(0, 100),
        destination_type: anchor ? 'page_section' : internal ? 'internal' : 'external',
      },
    }
  } catch {
    return null
  }
}
